import React, { Component } from 'react';
import nanoid from 'nanoid';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var ReCaptcha = (function (_super) {
    __extends(ReCaptcha, _super);
    function ReCaptcha() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scriptSrc = "https://www.google.com/recaptcha/api.js";
        _this.testSiteKey = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
        _this.observer = new MutationObserver(_this.mutationCallbackGenerator());
        _this.hiddenDiv = document.createElement("div");
        _this.id = nanoid();
        _this.successCallbackId = nanoid();
        _this.expiredCallbackId = nanoid();
        _this.errorCallbackId = nanoid();
        return _this;
    }
    ReCaptcha.prototype.componentDidMount = function () {
        this.observer.observe(document.body, { childList: true });
        this.appendScript();
        window[this.successCallbackId] = this.props.onSuccess;
        window[this.expiredCallbackId] = this.props.onExpire;
        window[this.errorCallbackId] = this.props.onError;
    };
    ReCaptcha.prototype.componentWillUnmount = function () {
        this.cleanup();
    };
    ReCaptcha.prototype.appendScript = function () {
        if (!this.getScriptIfAvailable()) {
            var reCaptchaScript = this.createScriptElement();
            document.body.appendChild(reCaptchaScript);
        }
    };
    ReCaptcha.prototype.getScriptIfAvailable = function () {
        var _this = this;
        if (document.getElementById("recaptcha") !== null) {
            return document.getElementById("recaptcha");
        }
        var availableScripts = Array.from(document.scripts);
        return availableScripts.find(function (script) { return script.src === _this.scriptSrc; });
    };
    ReCaptcha.prototype.createScriptElement = function () {
        var reCaptchaScript = document.createElement("script");
        reCaptchaScript.id = "recaptcha";
        reCaptchaScript.src = this.scriptSrc;
        reCaptchaScript.async = true;
        reCaptchaScript.defer = true;
        return reCaptchaScript;
    };
    ReCaptcha.prototype.cleanup = function () {
        var script = this.getScriptIfAvailable();
        if (script) {
            this.removeChild(script);
        }
        delete window[this.successCallbackId];
        delete window[this.expiredCallbackId];
        delete window[this.errorCallbackId];
        this.removeChild(this.hiddenDiv);
        var allScripts = Array.from(document.scripts);
        var reCaptchaSrcPattern = /https:\/\/www.gstatic.com\/recaptcha\/releases\/.*.js$/;
        var additionalScripts = allScripts.filter(function (script) {
            return reCaptchaSrcPattern.test(script.src);
        });
        additionalScripts.map(this.removeChild);
    };
    ReCaptcha.prototype.removeChild = function (element) {
        var parentNode = element.parentNode;
        if (parentNode !== null) {
            parentNode.removeChild(element);
        }
    };
    ReCaptcha.prototype.mutationCallbackGenerator = function () {
        var _this = this;
        return function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === "childList" &&
                    mutation.target === document.body &&
                    mutation.addedNodes.length === 1 &&
                    _this.isNodeReCaptchaHiddenDiv(mutation.addedNodes[0])) {
                    _this.hiddenDiv = mutation.addedNodes[0];
                    _this.observer.disconnect();
                }
            });
        };
    };
    ReCaptcha.prototype.isNodeReCaptchaHiddenDiv = function (node) {
        var div = node;
        return (div.style &&
            div.style.visibility === "hidden" &&
            div.style.top === "-10000px" &&
            div.style.position === "absolute");
    };
    ReCaptcha.prototype.render = function () {
        var _a = this.props, siteKey = _a.siteKey, theme = _a.theme, size = _a.size;
        return (React.createElement("div", { id: this.id, className: "g-recaptcha", "data-sitekey": siteKey === "test" ? this.testSiteKey : siteKey, "data-theme": theme, "data-size": size, "data-callback": this.successCallbackId, "data-expired-callback": this.expiredCallbackId, "data-error-callback": this.errorCallbackId }));
    };
    return ReCaptcha;
}(Component));

export default ReCaptcha;
